import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-base" }, "Add Color", -1)
const _hoisted_2 = { class: "flex items-center rounded text-xs pl-1.5 pr-1.5 py-0.5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-black" }, "$", -1)
const _hoisted_4 = { class: "dialog-footer" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("  Cancel ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("  Save ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_color_picker = _resolveComponent("el-color-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dialogVisible) = $event)),
    class: "font-bold",
    width: "35%"
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_4, [
        _createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.close()))
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onSubmit()))
        }, {
          default: _withCtx(() => [
            _hoisted_7,
            _hoisted_8
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        model: _ctx.state.attribute,
        "label-width": "20%",
        ref: "catalogAttribute",
        rules: _ctx.rules
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "Color Name",
            class: "font-bold",
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.state.attribute.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.attribute.name) = $event)),
                autocomplete: "off",
                placeholder: "Enter color name"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Select color",
            class: "font-bold",
            prop: "value"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_color_picker, {
                  modelValue: _ctx.state.attribute.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.attribute.value) = $event)),
                  size: "medium",
                  "color-format": "hex"
                }, null, 8, ["modelValue"]),
                _createElementVNode("span", null, _toDisplayString(_ctx.state.attribute.value), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Color Code",
            class: "font-bold",
            prop: "code"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.state.attribute.code,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.attribute.code) = $event)),
                autocomplete: "off",
                placeholder: "Enter color code (optional)"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (_ctx.costBy === 'color')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "Cost",
                class: "font-bold",
                prop: "cost"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.state.attribute.cost,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.attribute.cost) = $event)),
                    autocomplete: "off",
                    min: "0",
                    type: "number"
                  }, {
                    prefix: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}